// 根据用户id获取用户信息
export const SET_USER_INFO = 'SET_USER_INFO';